// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1uAH2","inputWrap":"Table_inputWrap__2nJjU","col":"Table_col__q1hLh","bmiTooltip":"Table_bmiTooltip__17IHo"};